export var CONSTS = {
  IFRAME_BASE_URL: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-iframe/',
  IFRAME_DEMO_MODE_URL: 'https://testing.arkadium.com/gameExamples/demo-games/sdk-demo/',
  EAGLE_AUTH_API_ENDPOINT: {
    dev: 'https://eagle-user-api-dev.arkadiumhosted.com/',
    prod: 'https://eagle-user-api-prod.arkadiumhosted.com/'
  },
  EAGLE_PAYMENT_API_ENDPOINT: {
    dev: 'https://eagle-payment-api.uup-aks-dev.arkadiumhosted.com',
    prod: 'https://arenacloud.cdn.arkadiumhosted.com/eagle-payment-api-prod/'
  },
  EAGLE_VIRTUAL_ITEMS_API_ENDPOINT: {
    dev: 'https://eagle-virtual-item-api.uup-aks-dev.arkadiumhosted.com/',
    prod: 'https://arenacloud.cdn.arkadiumhosted.com/eagle-virtual-item-api-prod/'
  },
  EAGLE_USER_GAME_DATA_API_ENDPOINT: {
    dev: 'https://arenacloud.cdn.arkadiumhosted.com/uup-api-user-data-dev/api/v1',
    prod: 'https://arenacloud.cdn.arkadiumhosted.com/uup-api-user-data-prod/api/v1'
  },
  GAMES_WITH_EAGLE_LIST_PATH: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/games-with-eagle-list.json',
  GRM_GAMES_LIST_URL: {
    arena51: {
      live: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/arena51/prod/index.json',
      staging: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/arena51/staging/index.json',
      canary: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/arena51/canary/index.json',
      dev: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/arena51/dev/index.json'
    },
    arkcom: {
      live: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/arkcom/prod/index.json',
      stage: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/arkcom/stage/index.json',
      dev: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/arkcom/dev/index.json'
    },
    aarp: {
      stage: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/aarp/stage/index.json',
      prod: 'https://arenacloud.cdn.arkadiumhosted.com/arkadiummodulesstorage-blob/game-rendering-games-list/aarp/prod/index.json'
    }
  },
  SDK_URL: 'https://developers.arkadium.com/cdn/sdk/v1/arena-sdk.js',
  PATH_TO_GAMES_URL: 'https://arenacloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-games/',
  PATH_TO_GAMES_URL_AARP: 'https://aarpcloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-games/'
};